import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from 'antd/es/tooltip';
import { cloneElement, isValidElement, useState, } from 'react';
const OVERFLOW_TOOLTIP_DELAY = 0.5;
const overflowTextStyle = {
    display: 'block',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
const isElementOverflowing = (element) => element.scrollWidth > element.clientWidth ||
    element.scrollHeight > element.clientHeight;
const isOverflowing = (element) => {
    if (isElementOverflowing(element))
        return true;
    return Array.from(element.querySelectorAll('*')).some(isElementOverflowing);
};
const OverflowTooltip = ({ title, children, className, mouseEnterDelay = OVERFLOW_TOOLTIP_DELAY, style, renderWrapper = true, }) => {
    const [isOverflowingText, setIsOverflowingText] = useState(false);
    const onMouseEnter = (event) => {
        setIsOverflowingText(isOverflowing(event.currentTarget));
    };
    if (!renderWrapper && isValidElement(children)) {
        const childElement = children;
        const childWithHandler = cloneElement(childElement, {
            onMouseEnter: (event) => {
                var _a, _b;
                onMouseEnter(event);
                (_b = (_a = childElement.props).onMouseEnter) === null || _b === void 0 ? void 0 : _b.call(_a, event);
            },
        });
        return (_jsx(Tooltip, { title: isOverflowingText ? title : undefined, mouseEnterDelay: mouseEnterDelay, children: childWithHandler }));
    }
    return (_jsx(Tooltip, { title: isOverflowingText ? title : undefined, mouseEnterDelay: mouseEnterDelay, children: _jsx("span", { className: className, style: Object.assign(Object.assign({}, overflowTextStyle), style), onMouseEnter: onMouseEnter, children: children }) }));
};
export default OverflowTooltip;
